var map = {
	"./de/group-logo.png": "DluX",
	"./en/group-logo.png": "m9sc",
	"./es/group-logo.png": "wO9l",
	"./fr/group-logo.png": "b0SG",
	"./ja/group-logo.png": "qayj",
	"./ko/group-logo.png": "2/0O",
	"./pt/group-logo.png": "14o7",
	"./ru/group-logo.png": "+mqO",
	"./tc/group-logo.png": "pM9R",
	"./th/group-logo.png": "Jj78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VOXf";